<template>
  <div class="app-page">
    <PageHeader />
    <div class="application-page-container">
      <section>
        <div class="btn-action-group">
          <a-button class="btn-item btn-upload" @click="uploadVisible = true" :disabled="disableUpload">
            <template #icon>
              <upload-outlined />
            </template>
            {{ $t('admin.Upload Employee List') }}
          </a-button>
          <a-button class="btn-item btn-export" @click="exportData">
            <template #icon>
              <DownloadOutlined />
            </template>
            {{ $t('admin.Download Employee List') }}
          </a-button>
          <a-button class="btn-item btn-upload" @click="batchUploadResultVisible = true" :disabled="isOnlinePeriod || !isCurrentPeriod">
            <template #icon>
              <upload-outlined />
            </template>
            {{ $t('admin.Batch Upload Result') }}
          </a-button>
          <a-button class="btn-item btn-export" @click="showHistory">
            <template #icon><history-outlined /></template>
            {{ $t('admin.View History') }}
          </a-button>
        </div>
        <div class="input-search-panel">
          <a-input-search v-model:value="keyword" allow-clear :placeholder="$t('admin.Employee / Review Manager / Brand')" :loading="loading" @search="onSearch" />
        </div>
      </section>
      <section class="application-counter">
        <div class="counter-text">
          <span>
            {{ $t('admin.Total') }}: {{ pagination.total }}
            {{ pagination.total > 1 ? $t('admin.Employees') : $t('admin.Employee') }}
          </span>
        </div>
        <div class="page-pagination">
          <a-pagination @change="fetchData" v-model:current="pagination.current" :total="pagination.total" v-model:pageSize="pagination.pageSize" :pageSizeOptions="pagination.pageSizeOptions" size="small" show-less-items show-size-changer show-quick-jumper />
        </div>
      </section>
      <div class="batch-action">
        <a-button class="btn-item btn-upload" @click="transferDialogVisible = true" :disabled="selectedRowKeys.length == 0">
          {{ $t('admin.Transfer') }}
        </a-button>
        <span>
          {{ $t('admin.Selected') }} {{ selectedRowKeys.length }}
          {{ $t('admin.items') }}
        </span>
      </div>
      <a-tabs v-model:activeKey="activeKey" @change="handleTabChange" type="card">
        <a-tab-pane v-for="period in periodRecord" :key="period.id" :tab="period.period_name"></a-tab-pane>
      </a-tabs>
      <a-table
        class="job-table"
        :rowKey="(record) => record.id"
        :columns="columns"
        :data-source="employeeRecord"
        @change="onChange"
        :row-selection="{
          selectedRowKeys,
          onChange: onSelectChange,
        }"
        :pagination="false"
      >
        <template v-slot:emptyText>
          <Empty />
        </template>
        <template v-slot:headerCell="{ title, column }">
          <!-- <template v-if="column.key === 'status'">
            <ApplyStatusHeader :title="$t('admin.' + title)" type="roled" />
          </template> -->
          <!-- <template v-else> -->
          {{ $t('admin.' + title) }}
          <!-- </template> -->
        </template>
        <template
          #customFilterDropdown="{
            // setSelectedKeys,
            // selectedKeys,
            confirm,
            clearFilters,
            column,
            visible,
          }"
        >
          <div class="custom-filter-header" v-if="column.key === 'current'">
            <RoleFilter :name="column.key" :visible="visible" :column="column" :setSelectedKeys="setSelectedCurrentRole" :selectedKeys="selectedCurrentRole" :confirm="confirm" :clearFilters="clearFilters" :cycleID="activeKey" />
          </div>
          <div class="custom-filter-header" v-if="column.key === 'target'">
            <RoleFilter :name="column.key" :visible="visible" :column="column" :setSelectedKeys="setSelectedTargetRole" :selectedKeys="selectedTargetRole" :confirm="confirm" :clearFilters="clearFilters" :cycleID="activeKey" />
          </div>
          <div class="custom-filter-header" v-if="column.key === 'brand'">
            <Filter :columnKey="column.key" :options="getOptions(column.key)" :confirm="confirm" :setSelectedKeys="setSelectedBrands" :selectedKeys="selectedBrands" :clearFilters="clearFilters" />
          </div>
          <div class="custom-filter-header" v-if="column.key === 'location'">
            <Filter :columnKey="column.key" :options="getOptions(column.key)" :confirm="confirm" :setSelectedKeys="setSelectedLocations" :selectedKeys="selectedLocations" :clearFilters="clearFilters" />
          </div>
          <div class="custom-filter-header" v-if="column.key === 'status'">
            <Filter :columnKey="column.key" :options="getOptions(column.key)" :confirm="confirm" :setSelectedKeys="setSelectedStatus" :selectedKeys="selectedStatus" :clearFilters="clearFilters" />
          </div>
        </template>
        <template v-slot:bodyCell="{ record, column }">
          <template v-if="column.key === 'status'">
            <ApplyStatusColumn :data="record" />
          </template>
          <template v-if="column.key === 'lion_id'">
            <span :class="{ highlight: record.lion_id.trim() == keyword.trim() }">
              {{ record.lion_id }}
            </span>
          </template>
          <template v-if="column.key === 'name'">
            <span :class="{ highlight: record.name.trim() == keyword.trim() }">
              {{ record.name }}
            </span>
          </template>
          <template v-if="column.key === 'lm_name'">
            <span :class="{ highlight: record.lm_name.trim() == keyword.trim() }">
              {{ record.lm_name }}
            </span>
          </template>
          <template v-else-if="column.key === 'action'">
            <div class="btn-groups">
              <a-button v-if="record.status != 0" :disabled="(record.status != 2 && record.status != -1 && record.status != 1) || !canReopen" type="link" @click="resetApply(record)">
                {{ $t('admin.Reopen Both') }}
              </a-button>
              <a-button v-if="record.status != 0" :disabled="(record.status != 2 && record.status != -1) || !canReopen" type="link" @click="reopenApply(record)">
                {{ $t('admin.Reopen Review Manager') }}
              </a-button>
              <a-button type="link" v-if="isCurrentPeriod && isOfflinePeriod" @click="openUpdateResultDialog(record)">
                {{ $t('admin.Update Result') }}
              </a-button>
              <br />
              <template v-if="record.status != 0">
                <a-button type="link" @click="viewApplyDetail(record)" v-if="record.status != 10">
                  {{ $t('admin.View Comments') }}
                </a-button>
                <a-button type="link" disabled v-else>
                  {{ $t('admin.View Comments') }}
                </a-button>
              </template>
            </div>
          </template>
        </template>
      </a-table>
      <div class="table-pagination">
        <div></div>
        <a-pagination @change="fetchData" v-model:current="pagination.current" :total="pagination.total" v-model:pageSize="pagination.pageSize" :pageSizeOptions="pagination.pageSizeOptions" size="small" show-less-items show-size-changer show-quick-jumper />
      </div>
    </div>
    <a-modal v-model:visible="transferDialogVisible" centered width="480px" :title="$t('admin.Transfer')" class="employee-uploade-dialog">
      <template #footer>
        <a-button type="default" @click="transferDialogVisible = false">
          {{ $t('admin.Cancel') }}
        </a-button>
        <a-button key="submit" type="primary" @click="handleTransferEmployee">
          {{ $t('admin.Transfer') }}
        </a-button>
      </template>
      <div class="">
        <a-form layout="vertical" ref="form" trigger="blur" :model="formData" @validate="handleValidate">
          <a-row :gutter="30">
            <a-col :span="12">
              <a-form-item :label="$t('admin.LLID of Review Manager')" name="lm_id" :rules="lmRule">
                <a-input :placeholder="$t('admin.Please Input')" v-model:value="formData.lm_id"></a-input>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item :label="$t('admin.LLID of HRBP')" name="hrbp_id" :rules="hrbpRule">
                <a-input :placeholder="$t('admin.Please Input')" v-model:value="formData.hrbp_id"></a-input>
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </div>
    </a-modal>
    <a-modal v-model:visible="uploadVisible" centered width="663px" title="Upload Employee List" class="employee-uploade-dialog" :loading="loading" @cancel="handleModalCancel">
      <template #footer>
        <a-button key="submit" type="primary" :loading="loading" @click="handleUploadDataChange">
          {{ $t('admin.Upload') }}
        </a-button>
      </template>
      <div class="step-tip-text">1. {{ $t('admin.Please download the template for uploading') }}</div>

      <a-button @click="downloadEmployeeTemplate">
        <DownloadOutlined />
        {{ $t('admin.Download Template') }}
      </a-button>

      <div class="step-tip-text">
        2.
        {{ $t('admin.Select the file (System will renew the items in the list from the uploaded document)') }}
      </div>
      <a-upload :file-list="fileList" :headers="{ Authorization }" @remove="handleRemove" :before-upload="beforeUpload">
        <a-button>
          <upload-outlined></upload-outlined>
          {{ $t('admin.Upload File') }}
        </a-button>
      </a-upload>
      <div class="step-tip-text">3. {{ $t('admin.Select ROAR Window') }}</div>
      <div>
        <a-radio-group class="radio-group" v-model:value="periodValueSelect">
          <a-radio class="radio" v-for="period in periodRecordSelect" :key="period.id" :value="period.id">
            {{ period.period_name }}
          </a-radio>
        </a-radio-group>
      </div>
    </a-modal>
    <a-modal v-model:visible="historyVisible" centered width="674px" :title="$t('admin.View History')" class="history-uploade-dialog">
      <template #footer>
        <a-button key="submit" type="primary" @click="historyVisible = false">
          {{ $t('admin.Close') }}
        </a-button>
      </template>
      <a-table
        class="history-table"
        :rowKey="(record) => record.id"
        :columns="[
          { title: $t('admin.User'), key: 'user', dataIndex: 'user' },
          { title: $t('admin.Action'), key: 'action', dataIndex: 'action' },
          {
            title: $t('admin.File Name'),
            key: 'filename',
            dataIndex: 'filename',
          },
          {
            title: $t('admin.Time of Action'),
            key: 'time',
            dataIndex: 'time',
          },
        ]"
        :data-source="historyList"
        :pagination="false"
      >
        <template v-slot:emptyText>
          <Empty />
        </template>
      </a-table>
    </a-modal>
    <a-modal v-model:visible="updateResultDialogVisible" centered width="600px" :title="$t('admin.Update Employee Result')" class="employee-result-dialog">
      <template #footer>
        <a-button type="default" @click="updateResultDialogVisible = false">
          {{ $t('admin.Cancel') }}
        </a-button>
        <a-button key="submit" type="primary" @click="handleUpdateResult">
          {{ $t('admin.Save') }}
        </a-button>
      </template>
      <div>
        <h3>{{ updateResultFormData.employee_name }}</h3>
        <br />
        <a-form layout="vertical" ref="updateResultForm" :model="updateResultFormData">
          <a-form-item :label="$t('admin.Panel Result')" name="status" :rules="[{ required: true, message: $t('admin.Please select the panel result') }]">
            <a-select v-model:value="updateResultFormData.status" :placeholder="$t('admin.Please select the panel result')">
              <a-select-option v-for="option in resultOptionsList" :key="option.value" :value="option.value">
                {{ option.label }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item :label="$t('admin.Result Comments')" name="result">
            <a-textarea v-model:value="updateResultFormData.result" :placeholder="$t('admin.Result Comments')" :rows="4" :maxlength="500" show-count />
          </a-form-item>
        </a-form>
      </div>
    </a-modal>
    <a-modal v-model:visible="batchUploadResultVisible" centered width="800px" :title="$t('admin.Batch Upload Result')" class="batch-upload-result-dialog">
      <template #footer>
        <a-button type="default" @click="batchUploadResultVisible = false">
          {{ $t('admin.Cancel') }}
        </a-button>
        <a-button key="submit" type="primary" @click="handleBatchUploadResult" :loading="batchUploadLoading" :disabled="!resultFileList.length || !previewData.length">
          {{ $t('admin.Confirm Upload') }}
        </a-button>
      </template>
      <div>
        <div class="step-tip-text">1. {{ $t('admin.Download Result Template') }}</div>
        <br />
        <a-button @click="downloadResultTemplate">
          <DownloadOutlined />
          {{ $t('admin.Download Result Template') }}
        </a-button>
        <br />
        <br />
        <div class="step-tip-text">2. {{ $t('admin.Select the result file (Excel)') }}</div>
        <br />
        <a-upload :file-list="resultFileList" :headers="{ Authorization }" @remove="handleResultFileRemove" :before-upload="beforeResultUpload" accept=".xlsx,.xls">
          <a-button>
            <upload-outlined></upload-outlined>
            {{ $t('admin.Upload Result File') }}
          </a-button>
        </a-upload>

        <div v-if="previewData.length > 0" class="preview-section">
          <a-divider>{{ $t('admin.Preview Data') }} ({{ $t('admin.Total Records') }}: {{ previewData.length }})</a-divider>
          <a-table :columns="previewColumns" :data-source="previewData" :pagination="{ pageSize: 10 }" size="small" :scroll="{ y: 300 }">
            <template v-slot:emptyText>
              <Empty />
            </template>
          </a-table>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import PageHeader from '../components/PageHeader.vue'
  import RoleFilter from '../components/RoleFilter.vue'
  import Filter from '../components/Filter.vue'
  import {
    // ApplyStatusHeader,
    ApplyStatusColumn,
  } from '@/components/ApplyStatus/index.js'
  import { ref, toRaw } from 'vue'
  import { getEmployeeHistoy, getEmployeeList, importEmployeeData, confirmEmployeeUpload, reOpenApplication, exportEmployeeData, getCycleList, reSetApplication, getRoleDListBrands, getRoleDListLocations, updateEmployeeResult, batchUpdateEmployeeResult, importResults, exportResultTemplate } from '@/api/admin'
  import { UploadOutlined, DownloadOutlined, HistoryOutlined } from '@ant-design/icons-vue'
  import { downLoadFileFromRequest, downLoadFileFromUrl } from '@/utils/index'
  import { Modal, message } from 'ant-design-vue'
  import { transferEmployee } from '../../../api/admin'
  import i18n from '@/locales'
  import bus from '@/lib/bus'
  import Empty from '@/components/Empty'
  import * as XLSX from 'xlsx'

  export default {
    name: 'Index',
    components: {
      // ApplyStatusHeader,
      ApplyStatusColumn,
      RoleFilter,
      Filter,
      PageHeader,
      UploadOutlined,
      DownloadOutlined,
      HistoryOutlined,
      Empty,
    },
    data() {
      return {
        activeKey: ref(1),
        periodValue: ref(0),
        periodValueSelect: ref(0),
        loading: false,
        uploadDataUrl: '/api/RoleC/Import',
        keyword: '',
        filteredInfo: {},
        sortedInfo: {},
        pagination: {
          total: 0,
          current: 1,
          pageSize: 10,
          pageSizeOptions: ['10', '30', '50'],
        },
        employeeRecord: [],
        transferDialogVisible: false,
        uploadVisible: false,
        disableUpload: false,
        fileList: [],
        allSelectedRowKeys: [],
        selectedRowKeys: [],
        historyVisible: false,
        historyList: [],
        allPeriods: [],
        periodRecord: [],
        periodRecordSelect: [],
        formData: [],
        roleDBrands: [],
        roleDLocations: [],
        roleDStatus: [
          {
            text: this.$t('user.Pending'),
            value: 'pd',
          },
          {
            text: this.$t('user.Approve for Panel'),
            value: 'ap',
          },
          {
            text: this.$t('user.Reopen'),
            value: 'ro',
          },
          {
            text: this.$t('user.Disapprove for Panel'),
            value: 'dp',
          },
          {
            text: this.$t('user.No Application'),
            value: 'na',
          },
          {
            text: this.$t('user.Promotion'),
            value: 'r1',
          },
          {
            text: this.$t('user.Salary Adjustment'),
            value: 'r2',
          },
          {
            text: this.$t('user.Transfer'),
            value: 'r3',
          },
          {
            text: this.$t('user.Try Again Next Time'),
            value: 'r4',
          },
          {
            text: this.$t('user.No show'),
            value: 'r5',
          },
          {
            text: this.$t('user.No Participation_Not Win'),
            value: 'r6',
          },
          {
            text: this.$t('user.Resigned'),
            value: 'r7',
          },
        ],
        selectedCurrentRole: [],
        selectedTargetRole: [],
        selectedBrands: [],
        selectedLocations: [],
        selectedStatus: [],
        statusFilterVisible: false,
        updateResultDialogVisible: false,
        updateResultFormData: {
          employee_id: null,
          status: null,
          result: '',
          employee_name: '',
        },
        resultOptions: [],
        batchUploadResultVisible: false,
        batchUploadLoading: false,
        resultFileList: [],
        previewData: [],
        previewColumns: [],
      }
    },
    computed: {
      ...mapGetters({
        Authorization: 'user/accessToken',
        ability: 'acl/ability',
      }),
      canUpLoad() {
        const ability = this.ability.find((item) => item.key === 'can_upload_employee')
        return ability.value
      },
      canReopen() {
        const ability = this.ability.find((item) => item.key === 'hrbp_reviewing')
        return ability.value
      },
      isOnlinePeriod() {
        const currentPeriod = this.periodRecord.find((period) => period.id === this.activeKey)
        return currentPeriod && currentPeriod.offline_mode === 0
      },
      isOfflinePeriod() {
        const currentPeriod = this.periodRecord.find((period) => period.id === this.activeKey)
        return currentPeriod && currentPeriod.offline_mode === 1
      },
      isCurrentPeriod() {
        const currentPeriod = this.allPeriods.find((period) => period.id === this.activeKey)
        return currentPeriod && currentPeriod.status === 1
      },
      // notUploadable() {
      //   return (
      //     this.periodRecordSelect
      //       .map((item) => item.id)
      //       .indexOf(this.activeKey) === -1
      //   )
      // },
      columns() {
        return [
          {
            title: 'Lion ID',
            key: 'lion_id',
          },
          {
            title: 'Name',
            key: 'name',
          },
          { title: 'Review Manager', key: 'lm_name' },
          // { title: 'HRBP', key: 'hrbp_name' },
          {
            title: 'Current Role',
            key: 'current',
            customFilterDropdown: true,
            filteredValue: this.selectedCurrentRole,
          },
          {
            title: 'Target Role',
            key: 'target',
            customFilterDropdown: true,
            filteredValue: this.selectedTargetRole,
          },
          {
            title: 'Current Brand',
            key: 'brand',
            sort: true,
            customFilterDropdown: true,
            filteredValue: this.selectedBrands,
          },
          {
            title: 'Location',
            key: 'location',
            sort: true,
            customFilterDropdown: true,
            filteredValue: this.selectedLocations,
          },
          {
            title: 'Status',
            key: 'status',
            sort: true,
            customFilterDropdown: true,
            filteredValue: this.selectedStatus,
          },
          { title: 'Action', key: 'action', width: 200, textAlign: 'center' },
        ].map((item) => {
          item.dataIndex = item.key
          if (item.sort) {
            item.sorter = () => {}
          }
          return item
        })
      },
      isEn() {
        return i18n.global.locale == 'en-US'
      },
      resultOptionsList() {
        return [
          { label: '', value: '0' },
          { label: this.$t('user.Promotion'), value: 'Promotion' },
          { label: this.$t('user.Salary Adjustment'), value: 'Salary Adjustment' },
          { label: this.$t('user.Transfer'), value: 'Transfer' },
          { label: this.$t('user.No Participation_Not Win'), value: 'No Participation/Not Win' },
        ]
      },
    },
    async created() {
      await this.fetchTabData()

      if (this.$route.query.filteredInfo) {
        this.filteredInfo = JSON.parse(this.$route.query.filteredInfo)
        this.setSelectedBrands(this.filteredInfo.brand || [])
        this.setSelectedLocations(this.filteredInfo.location || [])
        this.setSelectedStatus(this.filteredInfo.status || [])
        if (this.filteredInfo.current) {
          const currentKeys = Object.keys(this.filteredInfo.current)
          const currentArray = currentKeys.map((el) => ({
            key: el,
            value: this.filteredInfo.current[el],
          }))
          this.setSelectedCurrentRole(currentArray || [])
        }
        if (this.filteredInfo.target) {
          const targetKeys = Object.keys(this.filteredInfo.target)
          const targetArray = targetKeys.map((el) => ({
            key: el,
            value: this.filteredInfo.target[el],
          }))
          this.setSelectedTargetRole(targetArray || [])
        }
      }
      if (this.$route.query.activekey) {
        this.handleTabChange(parseInt(JSON.parse(this.$route.query.activekey)), false)
      }
      if (this.$route.query.keyword) {
        this.keyword = this.$route.query.keyword
        await this.onSearch()
      }

      await this.fetchSettings()
      await this.fetchData()
    },
    async mounted() {
      const vm = this
      bus.on('loadEmployeeData', async (payload) => {
        if (payload.columnKey === 'brand') {
          vm.filteredInfo.brand = payload.data
        }
        if (payload.columnKey === 'location') {
          vm.filteredInfo.location = payload.data
        }
        if (payload.columnKey === 'status') {
          vm.filteredInfo.status = payload.data
        }
        if (payload.columnKey === 'current') {
          vm.filteredInfo.current = {
            agency: payload.data[0].value,
            role: payload.data[1].value,
            // level: payload.data[2].value,
          }
        }
        if (payload.columnKey === 'target') {
          vm.filteredInfo.target = {
            agency: payload.data[0].value,
            role: payload.data[1].value,
            // level: payload.data[2].value,
          }
        }

        await vm.fetchData()
        vm.$router.replace({
          path: `${vm.$route.path}`,
          query: {
            ...vm.$route.query,
            filteredInfo: `${JSON.stringify(vm.filteredInfo)}`,
          },
        })
      })
    },
    methods: {
      async fetchTabData() {
        const res = await getCycleList({ size: 100 })
        if (res.code == 200) {
          // 如果后端没有返回 offline_mode 字段，默认为线上模式(0)
          // TODO: 需要后端在 API 中返回 offline_mode 字段
          this.allPeriods = res.data.map((item) => ({
            ...item,
            offline_mode: item.offline_mode !== undefined ? item.offline_mode : 0,
          }))
          this.periodRecord = this.allPeriods.filter((period) => {
            // 离线模式或有员工的周期都显示
            return period.employee_counts > 0 || parseInt(period.offline_mode) === 1
          })
          this.periodRecordSelect = this.allPeriods.filter((period) => {
            return period.can_upload_employee_list
          })
          if (this.periodRecord.length > 0) {
            this.periodValue = this.periodRecord[0].id
            this.activeKey = this.periodRecord[0].id
          }
          if (this.periodRecordSelect.length > 0) {
            this.periodValueSelect = this.periodRecordSelect[0].id
          } else {
            this.disableUpload = true
          }
        }
      },
      async fetchSettings() {
        const brandsRes = await getRoleDListBrands({ cycle_id: this.activeKey })
        this.roleDBrands = brandsRes.data.map((el) => ({ text: el, value: el }))
        const locationsRes = await getRoleDListLocations({
          cycle_id: this.activeKey,
        })
        this.roleDLocations = locationsRes.data.map((el) => ({
          text: el,
          value: el,
        }))
      },
      fetchData() {
        let filters = { ...this.filteredInfo }
        if (!this.isEn && filters.current?.agency) {
          filters.current = {
            ...filters.current,
            agency_cn: filters.current.agency,
          }
        }

        if (!this.isEn && filters.current?.role) {
          filters.current = {
            ...filters.current,
            role_cn: filters.current.role,
          }
        }

        if (!this.isEn && filters.target?.agency) {
          filters.target = {
            ...filters.target,
            agency_cn: filters.target.agency,
          }
        }

        if (!this.isEn && filters.target?.role) {
          filters.target = {
            ...filters.target,
            role_cn: filters.target.role,
          }
        }

        let params = {
          pageSize: this.pagination.pageSize || 10,
          pageNum: this.pagination.current || 1,
          keywords: this.keyword,
          filters,
          sort: this.sortedInfo,
        }

        const cycle_id = this.allPeriods.find((item) => item.id === this.activeKey)?.id

        if (cycle_id) {
          params = { ...params, cycle_id }
        }

        this.loading = true
        return getEmployeeList(params)
          .then((res) => {
            this.pagination.total = res.page.total || 0
            this.employeeRecord = res.data
            return res
          })
          .finally(() => {
            this.loading = false
          })
      },
      async handleTransferEmployee() {
        try {
          await transferEmployee(toRaw(this.selectedRowKeys), this.activeKey, this.formData.hrbp_id, this.formData.lm_id)
          this.transferDialogVisible = false
          this.fetchData()
          this.selectedRowKeys = []
          this.formData.lm_id = ''
          this.formData.hrbp_id = ''
          message.success(this.$t('admin.You have successfully transferred the selected employees to the new manager/HRBP'))
        } catch (error) {
          message.error(this.$t('admin.Please enter the correct LionID'))
        }
      },
      formFinish() {
        alert(1)
        // transferEmployee()
      },
      async onSearch() {
        this.pagination.current = 1
        this.$router.replace({
          path: this.$route.path,
          query: { ...this.$route.query, keyword: this.keyword },
        })
        return this.fetchData()
      },
      onSelectChange(selectedRowKeys) {
        this.allSelectedRowKeys[this.pagination.current] = selectedRowKeys
        this.selectedRowKeys = this.allSelectedRowKeys.filter((item) => item != null).flatMap((item) => item)
      },

      onChange(pagination, filters, sorter) {
        if (typeof sorter.order == 'undefined') {
          delete this.sortedInfo[sorter.field]
        } else {
          this.sortedInfo = {}
          this.sortedInfo[sorter.field] = sorter.field + '.' + sorter.order
        }
        // if (filters.current) {
        //   const cfd = filters.current
        //   this.filteredInfo.current = {
        //     agency: cfd[0].value,
        //     role: cfd[1].value,
        //     level: cfd[2].value,
        //   }
        // } else {
        //   this.filteredInfo.current = {
        //     agency: [],
        //     role: [],
        //     level: [],
        //   }
        // }
        // if (filters.target) {
        //   const cfd = filters.target
        //   this.filteredInfo.target = {
        //     agency: cfd[0].value,
        //     role: cfd[1].value,
        //     level: cfd[2].value,
        //   }
        // } else {
        //   this.filteredInfo.target = {
        //     agency: [],
        //     role: [],
        //     level: [],
        //   }
        // }
        // this.filteredInfo.brand = this.selectedBrands || []
        // this.filteredInfo.location = this.selectedLocations || []
        // this.filteredInfo.status = this.selectedStatus || []

        // this.$router.replace({
        //   path: `${this.$route.path}`,
        //   query: { filteredInfo: `${JSON.stringify(this.filteredInfo)}` },
        // })

        return this.fetchData()
      },
      exportData() {
        exportEmployeeData(this.Authorization, this.activeKey).then(downLoadFileFromRequest)
      },
      handleUploadDataChange() {
        if (this.periodRecordSelect.length === 0) {
          message.warning(this.$t("admin.Please make sure there is at least one ROAR window and it's before apply start time"))
          return
        }

        const vm = this
        if (this.fileList.length > 0) {
          const formData = new FormData()
          formData.append('files', this.fileList[0])
          formData.append('cycle_id', this.periodValueSelect)
          this.loading = true
          importEmployeeData(formData)
            .then((res) => {
              console.log(res)
              if (res.code == 200) {
                message.success(this.$t('admin.You have successfully uploaded the Employee List.'))
                this.uploadVisible = false
                this.fileList = []
                this.onSearch()
              } else if (res.code == 301) {
                const fId = res.fId
                const cycle_id = this.periodValueSelect
                Modal.confirm({
                  title: this.$t('admin.Upload Employee List'),
                  okText: this.$t('admin.Yes'),
                  cancelText: this.$t('admin.No'),
                  closable: true,
                  content: this.$t('admin.Found the duplicated data. Do you want to replace?'),
                  onOk() {
                    vm.loading = true
                    confirmEmployeeUpload({ fId, cycle_id })
                      .then(
                        async (res) => {
                          vm.uploadVisible = false
                          vm.fileList = []
                          await vm.fetchTabData()
                          await vm.onSearch()
                          // await vm.fetchData()
                          message.success(vm.$t('admin.You have successfully uploaded the Employee List.'))
                        },
                        (err) => {
                          if (err.msg) {
                            message.error(err.msg)
                          } else {
                            message.error(vm.$t('admin.You did not upload the Employee List successfully'))
                          }
                        }
                      )
                      .finally(() => {
                        vm.loading = false
                      })
                  },
                })
              } else {
                message.error(vm.$t('admin.You did not upload the Employee List successfully'))
              }
            })
            .catch((err) => {
              message.error(err.msg || 'upload failed.')
            })
            .finally(() => {
              this.loading = false
            })
        }
      },
      handleRemove(file) {
        this.fileList = []
      },
      beforeUpload(file) {
        console.log(file)
        const isExcel = file.type === 'application/vnd.ms-excel' || file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        if (isExcel) {
          this.fileList = [file]
        } else {
          this.fileList = []
          message.error(this.$t('admin.Incorrect Excel template type.'))
        }

        return false
      },
      showHistory() {
        getEmployeeHistoy().then((res) => {
          if (res.code === 200) {
            this.historyList = res.data
            this.historyVisible = true
          }
        })
      },
      downloadEmployeeTemplate() {
        downLoadFileFromUrl('/template/employee.xlsx', 'employee.xlsx')
      },
      handleTabChange(activekey, deleteKeyword = true) {
        this.activeKey = activekey
        let query = this.$route.query

        if (deleteKeyword) {
          delete query.filteredInfo
          this.filteredInfo = {}
          this.setSelectedCurrentRole([])
          this.setSelectedTargetRole([])
          this.setSelectedBrands([])
          this.setSelectedLocations([])
          this.setSelectedStatus([])
          // delete query.keyword
          // this.keyword = ''
        }
        this.$router.replace({
          path: this.$route.path,
          query: { ...query, activekey },
        })

        this.periodValue = activekey
        this.allSelectedRowKeys = []
        this.selectedRowKeys = []
        this.pagination.current = 1
        if (this.periodRecordSelect.map((p) => p.id).indexOf(activekey) !== -1) {
          this.periodValueSelect = activekey
        } else {
          if (this.periodRecordSelect.length > 0) {
            this.periodValueSelect = this.periodRecordSelect[0].id
          }
        }
        this.fetchData()
        this.fetchSettings()
      },
      handleModalCancel() {
        if (this.periodRecord.length > 0) {
          this.periodValue = this.periodRecord[0].id
        }
      },
      reopenApply(record) {
        const vm = this
        Modal.confirm({
          title: this.$t('admin.Reopen'),
          okText: this.$t('admin.Yes'),
          cancelText: this.$t('admin.No'),
          closable: true,
          content: this.$t('admin.Are you sure you want to reopen review manager’s assessment?'),
          onOk() {
            return reOpenApplication(record.apply_id).then(
              (res) => {
                if (res.code === 200) {
                  message.success(vm.$t('admin.Review Manager can now re-assess.'))
                  vm.fetchData()
                } else {
                  message.info(res.msg)
                }
              },
              (err) => {
                message.info(err.msg || 'The system is busy. Try again later.')
              }
            )
          },
        })
      },
      handleValidate(...args) {
        console.log(args)
      },
      resetApply(record) {
        const vm = this
        Modal.confirm({
          title: this.$t('admin.Reopen'),
          okText: this.$t('admin.Yes'),
          cancelText: this.$t('admin.No'),
          closable: true,
          content: this.$t('admin.Are you sure you want to reopen review manager’s assessment and employee’s application?'),
          onOk() {
            return reSetApplication(record.apply_id).then(
              (res) => {
                if (res.code === 200) {
                  message.success(vm.$t('admin.Review manager and employee can now re-assess.'))
                  vm.fetchData()
                } else {
                  message.info(res.msg)
                }
              },
              (err) => {
                message.info(err.msg || 'The system is busy. Try again later.')
              }
            )
          },
        })
      },
      viewApplyDetail(record) {
        this.$router.push({
          path: `/master/permission/apply_detail/${record.apply_id}`,
        })
      },
      getOptions(key) {
        if (key === 'brand') {
          return this.roleDBrands
        } else if (key === 'location') {
          return this.roleDLocations
        } else if (key === 'status') {
          return this.roleDStatus
        }
        return []
      },
      setSelectedCurrentRole(value) {
        const _v = value.filter((el) => el.value.length > 0)
        this.selectedCurrentRole = _v
      },
      setSelectedTargetRole(value) {
        const _v = value.filter((el) => el.value.length > 0)
        this.selectedTargetRole = _v
      },
      setSelectedBrands(value) {
        this.selectedBrands = value
      },
      setSelectedLocations(value) {
        this.selectedLocations = value
      },
      setSelectedStatus(value) {
        this.selectedStatus = value
      },
      openUpdateResultDialog(record) {
        const statusMap = { 0: '0', 31: 'Promotion', 32: 'Salary Adjustment', 33: 'Transfer', 34: 'Try Again Next Time', 38: 'No Participation/Not Win' }
        this.updateResultFormData.employee_id = record.id
        this.updateResultFormData.employee_name = record.name || ''
        this.updateResultFormData.status = statusMap[record.status] || record.status
        this.updateResultFormData.result = record.result
        this.updateResultDialogVisible = true
      },
      async handleUpdateResult() {
        if (this.updateResultFormData.status === null || this.updateResultFormData.status === undefined) {
          message.warning(this.$t('admin.Please select the panel result'))
          return
        }

        try {
          await updateEmployeeResult({
            employee_id: this.updateResultFormData.employee_id,
            panel_result: this.updateResultFormData.status,
            panel_comments: this.updateResultFormData.result,
          })
          message.success(this.$t('admin.You have successfully updated the employee result'))
          this.updateResultDialogVisible = false
          this.fetchData()
        } catch (error) {
          message.error(this.$t('admin.Failed to update employee result'))
        }
      },
      downloadResultTemplate() {
        exportResultTemplate(this.Authorization, this.activeKey).then(downLoadFileFromRequest)
      },
      handleResultFileRemove() {
        this.resultFileList = []
        this.previewData = []
        this.previewColumns = []
      },
      beforeResultUpload(file) {
        const isExcel = file.type === 'application/vnd.ms-excel' || file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || file.name.endsWith('.xlsx') || file.name.endsWith('.xls')

        if (!isExcel) {
          message.error(this.$t('admin.Invalid file format') + '. ' + this.$t('admin.Please upload Excel file'))
          this.resultFileList = []
          return false
        }

        this.resultFileList = [file]

        // 读取Excel文件内容（前端解析，需要xlsx库）
        this.parseExcelFile(file)

        return false
      },
      parseExcelFile(file) {
        const reader = new FileReader()
        reader.onload = (e) => {
          try {
            const data = new Uint8Array(e.target.result)
            // 使用 xlsx 库解析 Excel 文件
            const workbook = XLSX.read(data, { type: 'array' })
            const firstSheet = workbook.Sheets[workbook.SheetNames[0]]
            const jsonData = XLSX.utils.sheet_to_json(firstSheet, { header: 1 })

            if (!jsonData || jsonData.length === 0) {
              message.warning(this.$t('admin.No valid data in file'))
              return
            }

            // 获取表头
            const headers = jsonData[0].map((h) => String(h || '').trim())

            // 设置预览表格列
            this.previewColumns = headers.map((header) => ({
              title: header,
              dataIndex: header.toLowerCase().replace(/\s+/g, '_'),
              key: header.toLowerCase().replace(/\s+/g, '_'),
              width: 150,
            }))

            // 解析数据行
            this.previewData = []
            for (let i = 1; i < jsonData.length; i++) {
              if (jsonData[i] && jsonData[i].length > 0) {
                const row = {}
                headers.forEach((header, index) => {
                  const key = header.toLowerCase().replace(/\s+/g, '_')
                  row[key] = jsonData[i][index] !== undefined ? String(jsonData[i][index]) : ''
                })
                this.previewData.push(row)
              }
            }

            if (this.previewData.length === 0) {
              message.warning(this.$t('admin.No valid data in file'))
            }
          } catch (error) {
            console.error('Excel parse error:', error)
            message.error(this.$t('admin.Invalid file format') + '. ' + this.$t('admin.Please upload Excel file'))
            this.previewData = []
          }
        }
        reader.readAsArrayBuffer(file)
      },
      async handleBatchUploadResult() {
        if (!this.resultFileList.length) {
          message.warning(this.$t('admin.Please upload Excel file'))
          return
        }

        this.batchUploadLoading = true

        try {
          // 调用后端API上传文件
          // resultFileList[0] 已经是原始的 File 对象，不需要 originFileObj
          await importResults(this.resultFileList[0], this.activeKey)

          message.success(this.$t('admin.Batch update successful'))
          this.batchUploadResultVisible = false
          this.resultFileList = []
          this.previewData = []
          this.previewColumns = []
          this.fetchData()
        } catch (error) {
          console.error('Batch upload error:', error)
          message.error(error.msg || this.$t('admin.Batch update failed'))
        } finally {
          this.batchUploadLoading = false
        }
      },
    },
  }
</script>

<style lang="less" scoped>
  .batch-action {
    padding-bottom: 10px;
    span {
      margin-left: 10px;
    }
  }
  @import url('@/styles/params.less');
  .application-page-container {
    margin: @app-conetent-margin;
    background-color: white;
  }
  .application-page-container {
    margin: @app-conetent-margin;
    background-color: white;
    padding: 24px;
    section {
      display: flex;
      justify-content: space-between;
    }
    .btn-action-group {
      .btn-item {
        margin-right: 12px;
        margin-bottom: 5px;
      }
    }
    .input-search-panel {
      width: 320px;
    }

    .application-counter {
      padding: 24px 0;
      align-items: center;
      .counter-text {
        font-size: 16px;
        font-weight: bold;
        color: #333333;
        line-height: 24px;
        span {
          margin-right: 12px;
        }
      }
    }
  }

  .table-pagination {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
  }
  :deep {
    .table-pagination,
    .page-pagination {
      .ant-pagination-item-active {
        a {
          color: white;
        }
        background-color: @primary-color;
      }
    }
  }
  .custom-filter-header {
    display: flex;
    justify-content: space-between;
  }
  .employee-uploade-dialog {
    .step-tip-text {
      font-size: 14px;
      font-family: Helvetica;
      color: #333333;
      line-height: 17px;
      margin: 20px 0;
    }

    .radio-group {
      display: flex;
      flex-direction: column;

      .radio {
        margin-bottom: 8px;
      }
    }
  }
  .history-uploade-dialog {
  }
  .history-table {
    max-height: 500px;
    overflow: auto;
  }

  span.highlight {
    color: @primary-color;
    font-weight: bold;
  }

  .employee-result-dialog {
    .comment-display {
      white-space: pre-wrap;
      word-break: break-word;
      min-height: 40px;
      color: #666;
    }
  }

  .batch-upload-result-dialog {
    .preview-section {
      margin-top: 20px;
      max-height: 400px;
      overflow: auto;
    }
  }
</style>
